import { Alert, Spacer, Text } from '@ksyos/design-system';
import { translateKey } from '../../../translate';
import { Loader } from '../../elements/common';

interface IProfessionalSummaryDataPlaceholderProps {
    hasContent: boolean;
    isLoading: boolean;
    loadFailed: boolean;
    messageFailed: string;
    messageNotFound: string;
}

export function ProfessionalSummaryDataPlaceholder(props: IProfessionalSummaryDataPlaceholderProps) {
    return (
        <>
            {props.isLoading && (
                <div className="layout center center-justified custom-loader">
                    <Spacer align="center">
                        <Loader large />
                        <Text
                            as="p"
                            size="sm"
                        >
                            {translateKey('professionalSummary.loading')}
                        </Text>
                    </Spacer>
                </div>
            )}

            {props.loadFailed && <Alert appearance="warning">{props.messageFailed}</Alert>}

            {!props.isLoading && !props.hasContent && <Alert appearance="warning">{props.messageNotFound}</Alert>}
        </>
    );
}
